import template from './BaseModal2.hbs';

import {BaseView, Prototype} from '../BaseView';

/**
 * @class BaseModal2
 * @extends BaseView
 *
 * @property {object} options
 * @property {BaseView} options.destroyWith - View to listen for a destroy event which will be then passed
 *                                            to the ModalBehavior
 * @property {Boolean} options.clickoutToClose - Optional flag to enable or disable the click out behavior of
 *                                                  Modal, defaults valuse is false
 * @property [{object}] options.sections - Optional property to add sections
 * @property [{object}] options.buttons - Optional property to add buttons
 */
@Prototype({
    template,
    className: 'df-ui-overlay',
    defaultOptions: {
        title: '',
        clickoutToClose: false,
    },
    events: {
        click: 'onClickOverlay',
    }
})
export class BaseModal2 extends BaseView {

    initialize (options) {
        this.options = _.extend({}, this.defaultOptions, options);

        if (options.destroyWith) {
            this.listenTo(options.destroyWith, 'destroy', this.closeModal);
        }
    }

    serializeData () {
        return _.extend({}, this.options, {
            closeModal: () => this.closeModal(),
        });
    }

    closeModal () {
        this.destroy();
    }

    onClickOverlay (e) {
        if (e.currentTarget === this.el && this.options.clickoutToClose) {
            this.closeModal();
        }
    }

}



// WEBPACK FOOTER //
// ./shared/view/BaseModal2/BaseModal2.js